import type { OptionState } from '@openx/types/options';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../../hooks/useOptionsByPathQuery';
import { toList } from '../toList';
import { toMapById } from '../toMapById';

export const useAdPlacementOptionsFetch = (): OptionState => {
  const {
    data: { optionsByPath = [] } = {},
    loading,
    refetch,
  } = useOptionsByPathQuery({
    variables: {
      path: 'deal.package.targeting.rendering_context.ad_placement',
    },
  });

  const list = useMemo(() => toList(optionsByPath), [optionsByPath]);
  const mapById = useMemo(() => toMapById(list), [list]);

  return useMemo(
    () => ({
      list,
      loading,
      mapById,
      refetch,
    }),
    [list, loading, mapById, refetch]
  );
};
